export default "__VITE_ASSET__e4834d87__"